import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteiCal, deleteiCalLite } from 'modules/_common/api';
import { useLite } from 'modules/_common/hooks';

export const useMutationDeleteiCal = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const queryClient = useQueryClient();

  const { isLite } = useLite();
  const apiCall = isLite ? deleteiCalLite : deleteiCal;

  return useMutation(apiCall, {
    onSuccess: () => {
      successToast(t('iCal connection deleted successfully.'));
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CM_ICAL_UNIT);
    },
    onError: () => errorToast(),
  });
};
